import React from 'react';

export const pageMeta = {
  "name": "Web Fetch API",
  "link": "/javascript/web-api/fetch"
};

export default function JavascriptWebApiFetch() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Web Fetch API</h2>
      <p>Route: /javascript/web-api/fetch</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
